<template>
    <section class="cusFollowList">
        <van-loading v-if="isLoading" size="24px" vertical style="margin-top: 120px;">加载中...</van-loading>
        <section v-if="!isLoading" class="card_list" v-for="follow in followList" :key="follow.id">
            <div class="card">
                <div class="item">
                    <div class="label"><p>创建时间</p></div>
                    <div class="info"><p>{{follow.gmtCreate}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>跟进方式</p></div>
                    <div class="info"><p>{{follow.followUpMethod | f_followUpMethod}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>跟进标签</p></div>
                    <div class="info"><p>{{follow.followUpLabel | f_followUpLabel}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>跟进人员</p></div>
                    <div class="info"><p>{{follow.salesmanName}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>跟进描述</p></div>
                    <div class="info"><p>{{follow.followUpDescription}}</p></div>
                </div>
            </div>                   
        </section>
        <section v-if="!isLoading && !followList.length" class="nodata_class">
            <div class="no_data">
                <img src="../../assets/img/customer_default.png" />
                <p>暂无跟进记录</p>
            </div>
        </section>
	</section>
</template>

<script>
import customerServer from "api/customer";

export default {
    name: "cusFollowList",
    props: {customerCode: String},
    data() {
        return {
            isLoading: true,
            followList: []
		};
    },    
    created() {
        this.getInfo();
	},
    actived() {
        this.getInfo();
	},
	mounted() {
	},	
    methods: {
        getInfo() {
            this.isLoading = true
            customerServer.getFollowPageList({customerCode: this.customerCode, pageNum: 1, pageSize: 100}).then((res) => {
                this.followList = res.data.list
                this.isLoading = false
            })
        },
    },
};
</script>

<style lang="scss">
	.cusFollowList {
        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .head {
                padding: 16px 30px;
                border-bottom: 1px solid #E9F0F8;

                h3 {
                    color: #303030;
                    font-size: 17px;
                    line-height: 22px;
                    font-weight: 500;
                }
            }

            .item {
                margin-left: 30px;
                padding: 16px 30px 16px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info {
                    max-width: 70%;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                    text-align: right;
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .nodata_class {
            background-color: #f8f8f8;
            display: flex;
            align-items: center;
            justify-content: center;

            .no_data {
                position: relative;

                img {
                    width: 252px;
                    display: inline-block;
                }

                p {
                    padding-top: 22px;
                    color: #4d5b80;
                    font-size: 16px;
                    text-align: center;
                }
            }
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/components/CusFollowList.vue